import type { CurrentUser as Me } from "@ai-admin/api/types";
import { useQuery } from "@tanstack/react-query";
import { createContext, type ReactNode, useContext } from "react";
import { trpc } from "./trpc.js";

interface SessionValue {
  user: Me | null;
  loading: boolean;
  refresh(): Promise<unknown>;
}

const SessionContext = createContext<SessionValue>({ user: null, loading: true, refresh: async () => {} });

export function SessionProvider({ children }: { children: ReactNode }) {
  const q = useQuery(trpc.auth.me.queryOptions());
  return (
    <SessionContext.Provider value={{ user: (q.data as Me | null | undefined) ?? null, loading: q.isPending, refresh: q.refetch }}>
      {children}
    </SessionContext.Provider>
  );
}

export const useSession = () => useContext(SessionContext);
